const isRawPrinter = !!window.Android || window.desktopApp;

export const lineToPrintHelper = isRawPrinter
  ? "\n------------------------------------------\n"
  : "";
